
$(document).ready(function(){
    $('#audio-upload-form').on('submit', function (e) {
        e.preventDefault();
        var _this = $(this);
        var formData = new FormData(this);
        $.ajax({
            type: 'POST',
            url: $(this).attr('action'),
            data: formData,
            cache: false,
            contentType: false,
            processData: false,
            success: function (data) {
                if (data && data.upload) {
                    $('#audio-upload-msg').html('File uploaded successfully!');
                    if($('#audio-upload-action').val() == 'select'){
                        widgetAdd('play', data.url, data.title, data.id);
                    } else if($('#audio-upload-action').val() == 'delete'){
                        listAudio('delete');
                    }
                } else {
                    $('#audio-upload-msg').html(data && !data.upload ? data.error : 'Some error occurred while uploading file.');
                }
                _this.find('button[type=submit]').removeClass('disabled');
                _this.find('button[type=submit]').text('Upload');
            },
            error: function (data) {
                $('#audio-upload-msg').html('Some error occurred while uploading file.');
                _this.find('button[type=submit]').removeClass('disabled');
                _this.find('button[type=submit]').text('Upload');
            },
            beforeSend: function(){
                _this.find('button[type=submit]').addClass('disabled');
                _this.find('button[type=submit]').text('Wait...');
            }
        });
    });

    $('#audio-widget-data').sortable();

    $('.has-ivr-option-name select[name=ivr_option_id], .has-ivr-option-name select[name=store_id]').change(function () {
        updateOptionName($('.has-ivr-option-name select[name=ivr_option_id]').val(), $('.has-ivr-option-name select[name=store_id]').val(), $(this).parent('has-ivr-option-name').hasClass('no-edit'));
    });
    $('.has-ivr-option-name select[name=ivr_option_id]').trigger('change');
});

function updateStoreIvrSetting(id, _this){
    $.ajax({
        type: 'POST',
        url: '/admin/store-ivr/update-setting',
        data: {
            id : id,
            store_ivr_id: $(_this).closest('tr').find('select').val()
        },
        cache: false,
        success: function (data) {
            $(_this).removeClass('disabled');
            $(_this).find('span:eq(1)').text('Update');
            $(_this).closest('td').find('div').text('Successful!');
        },
        error: function (data) {
            $(_this).removeClass('disabled');
            $(_this).find('span:eq(1)').text('Update');
            $(_this).closest('td').find('div').text('Error!');
        },
        beforeSend: function(){
            $(_this).closest('tbody').find('td button').removeClass('disabled');
            $(_this).closest('tbody').find('td div.msg').empty();
            $(_this).addClass('disabled');
            $(_this).find('span:eq(1)').text('Updating...');
        }
    });

    return false;
}

function audioManager(_this){
    if(!$('select[name=store_id]').val()){
        alert('Please select store.'); // unexpected error
        return;
    }
    $('#audio-upload-msg').empty();
    $('#audio-upload-storeid').val($('select[name=store_id]').val());
    $('#audio-upload-store-name').text($('select[name=store_id] option:selected').text());
    $('#audio-upload-action').val($(_this).attr('data-action'));
    $('#audio-upload-modal').modal('show');
    listAudio($(_this).attr('data-action'));
    return false;
}

function listAudio(action){
    $.ajax({
        type: 'POST',
        url: '/admin/store-ivr/list-audio',
        data: {
            store_id : $('#audio-upload-storeid').val(),
            action: action
        },
        cache: false,
        success: function (data) {
            $('#audio-list').html(data);
        },
        error: function (data) {
            $('#audio-list').html('<h3 class="center-msg">Some error occurred while fetching audio list.</h3>');
        },
        beforeSend: function(){
            $('#audio-list').html('<h3 class="center-msg">Loading audio list. Please wait...</h3>');
        }
    });
}

function audioDelete(id, _this){
    $.ajax({
        type: 'POST',
        url: '/admin/store-ivr/delete-audio',
        data: {
            id : id
        },
        cache: false,
        success: function (data) {
            if(data == 'in-use'){
                $(_this).removeClass('disabled');
                $(_this).find('span:eq(1)').text('Delete');
                $('#audio-upload-msg').html('File is currently being used by some resource.');
            } else {
                $(_this).closest('tr').remove();
            }
        },
        error: function (data) {
            $(_this).removeClass('disabled');
            $(_this).find('span:eq(1)').text('Delete');
            $('#audio-upload-msg').html('Some error occurred. Please try again.');
        },
        beforeSend: function(){
            $(_this).addClass('disabled');
            $(_this).find('span:eq(1)').text('Wait ...');
        }
    });

    return false;
}

function deleteStoreIvr(id, _this){
    $.ajax({
        type: 'POST',
        url: '/admin/store-ivr/delete-store-ivr',
        data: {
            id : id
        },
        cache: false,
        success: function (data) {
            if(data == 'in-use'){
                $(_this).removeClass('disabled');
                $(_this).find('span:eq(1)').text('Delete');
                $(_this).closest('td').find('div').text('File is currently being used by some IVR setting.');
            } else {
                $(_this).closest('tr').remove();
            }
        },
        error: function (data) {
            $(_this).removeClass('disabled');
            $(_this).find('span:eq(1)').text('Delete');
            $(_this).closest('td').find('div').text('Some error occurred.');
        },
        beforeSend: function(){
            $(_this).closest('tbody').find('td button').removeClass('disabled');
            $(_this).closest('tbody').find('td div.msg').empty();
            $(_this).addClass('disabled');
            $(_this).find('span:eq(1)').text('Wait ...');
        }
    });

    return false;
}

function testIvrResource(id, _this){
    $.ajax({
        type: 'POST',
        url: '/admin/store-ivr/test-ivr-resource',
        data: {
            id : id
        },
        cache: false,
        success: function (data) {
            $(_this).find('span:eq(1)').text('Attach To Test No.');
            $(_this).closest('td').find('div').text('Successful!');
            $('#ivr-resource-test').html(data);
            $(window).scrollTop(0);
        },
        error: function (data) {
            $(_this).removeClass('disabled');
            $(_this).find('span:eq(1)').text('Attach To Test No.');
            $(_this).closest('td').find('div').text('Some error occurred.');
        },
        beforeSend: function(){
            $(_this).closest('tbody').find('td button').removeClass('disabled');
            $(_this).closest('tbody').find('td div.msg').empty();
            $(_this).addClass('disabled');
            $(_this).find('span:eq(1)').text('Wait ...');
        }
    });
}


function addPause(_this){
    widgetAdd('pause');
    return false;
}

function addSay(_this){
    widgetAdd('say');
    return false;
}

function widgetAdd(type, url, title, id){
    var html = '';
    if(type === 'play'){
        html += '<div class="alter alert-success alert-dismissible audio-widget-play widget-control" role="alert" data-type="play">';
        html += '<input type="hidden" data-name="id" value="'+ id +'">';
        html += '<button type="button" class="close" onclick="$(this).parent(\'div\').remove();"><span aria-hidden="true">&times;</span></button>';
        html += '<div class="title">'+ title +'</div>';
        html += '<div><audio controls="" preload="metadata" src="'+ url +'">Your browser does not support the <code>audio</code> element for previews.</audio></div>';
        html += '<div class="loop">Loop: <input type="text" data-name="loop" value="1" maxlength="2" class="form-control"></div>';
        html += '</div>';
    } else if (type === 'pause'){
        html += '<div class="alter alert-warning alert-dismissible audio-widget-pause widget-control" role="alert" data-type="pause">';
        html += '<button type="button" class="close" onclick="$(this).parent(\'div\').remove();"><span aria-hidden="true">&times;</span></button>';
        html += '<div class="title">Pause</div>';
        html += '<div class="length">Length (seconds): <input type="text" data-name="length" value="2" maxlength="3" class="form-control"></div>';
        html += '</div>';
    } else if (type === 'say'){
        html += '<div class="alter alert-info alert-dismissible audio-widget-say widget-control" role="alert" data-type="say">';
        html += '<button type="button" class="close" onclick="$(this).parent(\'div\').remove();"><span aria-hidden="true">&times;</span></button>';
        html += '<input type="hidden" data-name="language" value="en"><div class="title">Text To Speech</div>';
        html += '<div class="text">Text: <textarea data-name="text" class="form-control" row="2"></textarea></div>';
        html += '<div><span class="loop">Loop: <input type="text" data-name="loop" value="1" maxlength="2" class="form-control"></span>';
        html += '<span class="voice">Voice: <select data-name="voice" class="form-control"><option value="woman">Woman</option>';
        html += '<option value="man">Man</option><option value="alice">Alice</option></select></span></div>';
        html += '</div>';
    }

    $('#audio-widget-data').append(html);
    $('#audio-upload-modal').modal('hide');
    return false;
}

function widgetSubmit(_this){
    $(_this).find('div.form-group .help-block').empty();
    $(_this).find('div.form-group input, div.form-group select, div.form-group .box').removeClass('error');

    var category = $(_this).find('.store_ivr_category_id select').val();
    if(!category){
        $(_this).find('.store_ivr_category_id .help-block').text('Required*');
        $(_this).find('.store_ivr_category_id select').addClass('error');
        return false;
    }

    var title = $(_this).find('.title input').val();
    if(!title || !title.trim()){
        $(_this).find('.title .help-block').text('Required*');
        $(_this).find('.title input').addClass('error');
        return false;
    }

    var response = [];
    var hasVoice = false;
    var hasError = false;
    var error = '';
    $('#audio-widget-data .widget-control').each(function(i, v){
        var type = $(this).attr('data-type');
        if(type === 'play'){
            var id = $(this).find('input[data-name=id]').val();
            var loop = $(this).find('input[data-name=loop]').val();

            if(!id || !parseInt(id) || parseInt(id) <= 0){
                hasError = true;
                error = 'Unexpected error occurred. Please refresh the page.';
                return false;
            }

            if(!loop || !parseInt(loop) || parseInt(loop) < 1){
                hasError = true;
                error = 'Loop count is required (Min: 1).';
                return false;
            }

            var obj = {};
            obj.type = type;
            obj.id = parseInt(id);
            obj.loop = parseInt(loop);
            response.push(obj);
            hasVoice = true;
        } else if (type === 'pause') {
            var length = $(this).find('input[data-name=length]').val();

            if(!length || !parseInt(length) || parseInt(length) < 1){
                hasError = true;
                error = 'Pause length is required (Min: 1 sec).';
                return false;
            }

            var obj = {};
            obj.type = type;
            obj.length = parseInt(length);
            response.push(obj);
        } else if (type === 'say') {
            var text = $(this).find('textarea[data-name=text]').val();
            var loop = $(this).find('input[data-name=loop]').val();
            var language = $(this).find('input[data-name=language]').val();
            var voice = $(this).find('select[data-name=voice]').val();

            if(!language){
                hasError = true;
                error = 'Language is required.';
                return false;
            }

            if(!voice){
                hasError = true;
                error = 'Voice is required.';
                return false;
            }

            if(!text || !text.trim()){
                hasError = true;
                error = 'Text is required.';
                return false;
            }

            if(!loop ||  !parseInt(loop) || parseInt(loop) < 1){
                hasError = true;
                error = 'Loop count is required (Min: 1).';
                return false;
            }

            var obj = {};
            obj.type = type;
            obj.text = text;
            obj.loop = parseInt(loop);
            obj.language = language;
            obj.voice = voice;
            response.push(obj);
            hasVoice = true;
        }
    });

    if(hasError){
        $(_this).find('.response .help-block').text(error);
        $(_this).find('.response .box').addClass('error');
        return false;
    }

    if(response.length === 0 || !hasVoice){
        $(_this).find('.response .help-block').text('Response is required. Please include atleast one audio or "text to speech".');
        $(_this).find('.response .box').addClass('error');
        return false;
    }

    $(_this).find('input[name=response]').val(JSON.stringify(response));
    return true;
}

function updateStoreIvrOption(id, _this){
    var name = $(_this).closest('tr').find('input').val();
    if(!name || !name.trim()){
        $(_this).closest('td').find('div').text('Title is required!');
        return;
    }
    $.ajax({
        type: 'POST',
        url: '/admin/store-ivr/update-option',
        data: {
            id : id,
            name: name.trim()
        },
        cache: false,
        success: function (data) {
            $(_this).removeClass('disabled');
            $(_this).find('span:eq(1)').text('Update');
            $(_this).closest('td').find('div').text('Successful!');
        },
        error: function (data) {
            $(_this).removeClass('disabled');
            $(_this).find('span:eq(1)').text('Update');
            $(_this).closest('td').find('div').text('Error!');
        },
        beforeSend: function(){
            $(_this).closest('tbody').find('td button').removeClass('disabled');
            $(_this).closest('tbody').find('td div.msg').empty();
            $(_this).addClass('disabled');
            $(_this).find('span:eq(1)').text('Updating...');
        }
    });

    return false;
}

function updateOptionName(id, store_id, editable){
    if(editable){
        $('.has-ivr-option-name .ivr-option-name input').attr('readonly', false);
    }
    $('.has-ivr-option-name .ivr-option-name input').attr('placeholder', '');
    if(id == '6'){
        $('.has-ivr-option-name .ivr-option-name').hide();
        $('.has-ivr-option-name .ivr-option-name input').val('');
    } else {
        $('.has-ivr-option-name .ivr-option-name').show();
        if(!store_id || parseInt(store_id) <= 0) {
            $('.has-ivr-option-name .ivr-option-name input').val('');
            return;
        }
        $.ajax({
            type: 'POST',
            url: '/admin/store-ivr/option-name',
            data: {
                id : id,
                store_id: store_id
            },
            cache: false,
            success: function (data) {
                $('.has-ivr-option-name .ivr-option-name input').val(data);
                if(editable){
                    $('.has-ivr-option-name .ivr-option-name input').attr('readonly', false);
                }
                $('.has-ivr-option-name .ivr-option-name input').attr('placeholder', '');
            },
            error: function (data) {
                $('.has-ivr-option-name .ivr-option-name input').attr('placeholder', 'Error! Refresh the page.');
            },
            beforeSend: function(){
                if(editable){
                    $('.has-ivr-option-name .ivr-option-name input').attr('readonly', 'readonly');
                }
                $('.has-ivr-option-name .ivr-option-name input').val('');
                $('.has-ivr-option-name .ivr-option-name input').attr('placeholder', 'Wait...');
            }
        });
    }
}
